// src/components/holidays/delete.js

import { useContext, useCallback } from "react";
import UIkit from "uikit";
import { AppContexts } from "../../providers";

const HolidayDelete = () => {
  const holidaysContext = useContext(AppContexts.HolidaysContext);
  const { holiday, deleteHoliday } = holidaysContext;

  const handleDelete = useCallback(async () => {
    if (!holiday?.id) return;

    try {
      const ok = await deleteHoliday(holiday.id);
      if (ok) {
        UIkit.modal("#modal-holiday-delete").hide();
        UIkit.notification("Holiday deleted", "success");
        holidaysContext.setHoliday({});
      } else {
        UIkit.notification("Failed", "error");
      }
    } catch (e) {
      UIkit.notification("Failed", "error");
    }
  }, [holiday?.id]);

  return (
    <div id="modal-holiday-delete" uk-modal="true">
      <div className="uk-modal-dialog uk-modal-body">
        <h2 className="uk-modal-title">Delete Holiday</h2>
        <p>
          Are you sure you want to delete <b>{holiday?.name}</b>?
        </p>
        <p className="uk-text-right">
          <button className="uk-button uk-button-default uk-modal-close" type="button">
            Cancel
          </button>
          <button className="uk-button uk-button-danger" type="button" onClick={handleDelete}>
            Delete
          </button>
        </p>
      </div>
    </div>
  );
};

export default HolidayDelete;